import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

import { tarefaService } from "@/services/api/tarefa.service";
import { tarefasKeys } from "@/services/api/queries/tarefas.queries";
import { DadosConclusaoDTO } from "@/types/conclusao.type";

/**
 * Conclusão de tarefa com suporte ao modelo híbrido: tarefas com formulário
 * enviam `dadosConclusao` (validados no backend contra o schema). Invalida o
 * detalhe e as listas.
 */
export function useConcluirTarefa(onConcluida?: () => void) {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: ({ id, dados }: { id: number; dados?: DadosConclusaoDTO }) =>
      tarefaService.concluir(id, dados),
    onSuccess: (_data, { id }) => {
      toast.success("Tarefa concluída com sucesso!");
      tarefasKeys.allLists().forEach((key) => queryClient.invalidateQueries({ queryKey: key }));
      queryClient.invalidateQueries({ queryKey: ["tarefa", id] });
      queryClient.invalidateQueries({ queryKey: ["tarefas-pendentes-count"] });
      queryClient.invalidateQueries({ queryKey: ["tarefas-notificacoes"] });
      onConcluida?.();
    },
    onError: (error) => {
      console.error("Erro ao concluir tarefa.", error);
    },
  });

  return {
    concluir: mutation.mutate,
    concluirAsync: mutation.mutateAsync,
    isConcluindo: mutation.isPending,
  };
}
